import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import SellInvoiceRefundStatusBar, { InvoiceRefundCreateStatusBarProps, SellInvoiceRefundStatusBarNew } from '../SellInvoiceRefundStatusBar'
import SellInvoiceRefundFinishedStepButtons, { SellInvoiceRefundFinishedStepButtonsNew } from '../Steps/SellInvoiceRefundFinishedStep/SellInvoiceRefundFinishedStepButtons'

type SellInvoiceRefundFinishedStepHeaderProps = & InvoiceRefundCreateStatusBarProps & OrderStepButtonsBaseComponentProps

const SellInvoiceRefundFinishedStepHeaderDecider: React.FC<SellInvoiceRefundFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellInvoiceRefundFinishedStepHeaderDefault} NewComponent={SellInvoiceRefundFinishedStepHeaderNew} {...rest} />
    )
}

const SellInvoiceRefundFinishedStepHeaderDefault: React.FC<SellInvoiceRefundFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellInvoiceRefundStatusBar {...rest} />
            <SellInvoiceRefundFinishedStepButtons {...rest} />
        </div>
    )
}

const SellInvoiceRefundFinishedStepHeaderNew: React.FC<SellInvoiceRefundFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellInvoiceRefundStatusBarNew {...rest} />
            <SellInvoiceRefundFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellInvoiceRefundFinishedStepHeaderDecider